<template>
  <svg
    class="shrink-0"
    style=""
    :width="width"
    :height="width"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.25 3.48768C10.3075 3.29518 8.35333 3.19602 6.405 3.19602C5.25 3.19602 4.095 3.25435 2.94 3.37102L1.75 3.48768M4.95833 2.89852L5.08667 2.13435C5.18 1.58018 5.25 1.16602 6.23583 1.16602H7.76417C8.75 1.16602 8.82583 1.60352 8.91333 2.14018L9.04167 2.89852M10.9958 5.33102L10.6167 11.2052C10.5525 12.121 10.5 12.8327 8.8725 12.8327H5.1275C3.5 12.8327 3.4475 12.121 3.38333 11.2052L3.00417 5.33102M6.02583 9.62435H7.96833M5.54167 7.29102H8.45833"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconBin',
  props: {
    color: String
  }
})
export default class extends Vue {
  @Prop({ default: '#ffffff' }) private color!: String;
  @Prop({ default: '14' }) width!: string;
  @Prop({ default: '14' }) height!: string;
  @Prop({ default: '1.5' }) strokeWidth!: string;
}
</script>

<style scoped>
</style>
